// extracted by mini-css-extract-plugin
module.exports = {"main-component":"emailSend_main-component__1b4s0"};